import { render, staticRenderFns } from "./TabloView.vue?vue&type=template&id=195fd1d6&scoped=true&"
import script from "./TabloView.vue?vue&type=script&lang=js&"
export * from "./TabloView.vue?vue&type=script&lang=js&"
import style0 from "./TabloView.vue?vue&type=style&index=0&id=195fd1d6&scoped=true&lang=scss&"
import style1 from "./TabloView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195fd1d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
